<script lang="ts" setup>
import type { IProps } from './PartnershipsItem.types'
defineProps<IProps>()
</script>

<template>
  <div class="partnerships-item">
    <img
      v-if="item.image"
      :src="item.image.url"
      :alt="item.image.alternative"
      class="partnerships-item__logo"
    >
    
    <h3 class="partnerships-item__heading">
      {{ item.title }}
    </h3>

    <ul class="partnerships-item__details">
      <li
        v-for="(detail, index) in item.details"
        :key="`partnerships-item__detail-${index}`"
        class="partnerships-item__detail"
      >
        {{ detail }}
      </li>
    </ul>

    <div
      class="partnerships-item__text"
      v-html="item.text"
    />
  </div>
</template>

<style lang="scss" scoped>
.partnerships-item {
  display: flex;
  flex: 0 1 calc(50% - 1.6rem);
  flex-direction: column;
  align-items: flex-start;
  padding: 3.2rem;
  background-color: $white;
  border-radius: 1.6rem;

  &__logo {
    width: auto;
    margin-bottom: 1.6rem;
  }

  &__heading {
    @include h9;
    margin-bottom: 1.6rem;
  }

  &__details {
    margin-bottom: 1.6rem;

    li {
      color: $text-300;
      @include h10;
    }
  }

  &__text {
    @include body-1-medium;
    height: 100%;
    color: $text-300;
  }

  @include atM {
    padding: 3.2rem;

    &__text {
      @include h10;
    }

    &__heading {
      @include h9;
    }
  }
}
</style>
